module.exports = __webpack_public_path__ + "img/1.2c5b9ea0.png";